import { Device } from '@/types/device';
import { isAlexaDevice } from '@/utils/device-helpers';

export type SkillDriftSummary = {
  reportingCount: number;
  divergentCount: number;
  alexaDeviceCount: number;
};

export const getSkillDriftSummary = (
  skillId: string,
  devices: Device[],
): SkillDriftSummary => {
  const alexaDevices = devices.filter(isAlexaDevice);
  let reportingCount = 0;
  let divergentCount = 0;

  for (const device of alexaDevices) {
    const entry = device.state?.skills?.find((s) => s.skillId === skillId);
    if (!entry) continue;
    reportingCount += 1;
    if (entry.divergent) divergentCount += 1;
  }

  return {
    reportingCount,
    divergentCount,
    alexaDeviceCount: alexaDevices.length,
  };
};
